/* eslint-disable react/destructuring-assignment */

import React from 'react'
import { Field, FieldProps, FieldRenderProps } from 'react-final-form'
import TextField from 'components/ui/TextField'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EMPTY_FIELD_PROPS: Partial<FieldProps<any, any>> = {}

type TextFieldProps = {
  label?: string
  description?: string
  placeholder?: string
  autoComplete?: string
  type?: string
  newDesign?: boolean
  prefix?: React.ReactNode
}

export type Props = TextFieldProps & {
  name: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldProps?: Partial<FieldProps<any, any>>
}

function InnerFormTextField({
  input,
  label,
  description,
  autoComplete,
  placeholder,
  newDesign,
  prefix,
  meta: { touched, error: syncError, submitError, submitting }
}: FieldRenderProps<string, HTMLInputElement> & TextFieldProps) {
  const error = syncError || submitError
  const showError = (touched || submitError) && !!error
  return (
    <TextField
      autoComplete={autoComplete}
      description={description}
      disabled={submitting}
      error={showError ? error : null}
      label={label}
      newDesign={newDesign}
      placeholder={placeholder}
      prefix={prefix}
      {...input}
    />
  )
}

export default function FormTextField({
  name,
  type,
  fieldProps = EMPTY_FIELD_PROPS,
  ...innerProps
}: Props) {
  return (
    <Field<string, FieldRenderProps<string, HTMLInputElement>, HTMLInputElement>
      name={name}
      render={(props) => (
        <InnerFormTextField
          {...props}
          {...innerProps}
          name={name}
          type={type}
        />
      )}
      type={type}
      {...fieldProps}
    />
  )
}
